export const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const validateInputFields = (referredByDocId, formData, selectedFile, selectedDoctor) => {
    if (!referredByDocId) {
        return "LoginAgain";
    }

    if (!selectedDoctor) {
        return "ReferredDoctorErr";
    }

    if (!formData.PatientName || formData.PatientName.trim() === "") {
        return "PatientNameErr";
    }

    if (!formData.PatientEmail || formData.PatientEmail.trim() === "") {
        return "PatientEmailErr";
    }

    if (!isValidEmail(formData.PatientEmail)) {
        return "InvalidPatientErr";
    }

    if (!formData.PatientNumber || formData.PatientNumber.trim() === "") {
        return "PatientPhoneNumberErr";
    }

    if (!formData.PatientID || formData.PatientID.trim() === "") {
        return "PatientIDErr";
    }

    if (!selectedFile) {
        return "pleaseUploadErr";
    }

    return "";
};
